<template lang="html">
  <div>
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>

    <v-container
      v-if="course"
      fluid
      class="pa-0 ma-0"
    >
      <slot name="navigation" />
      <v-row>
        <v-col
          cols="12"
        >
          <v-col
            cols="12"
          >
            <v-card
              class="mx-auto"
            >
              <v-list-item
                class="ml-0 pt-1 white--text"
                style="background:#00896e url(https://www.transparenttextures.com/patterns/bright-squares.png) repeat !important"
              >
                <v-list-item-avatar size="100">
                  <img
                    :src="course.image_url"
                  >
                </v-list-item-avatar>

                <v-list-item-content class="white--text">
                  <v-list-item-title class="headline">
                    {{ course.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="white--text">
                    {{ course.description }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-tabs v-model="active">
                <v-tab>Course Details</v-tab>
                <v-tab>Materials</v-tab>
                <v-tab>Exams</v-tab>
              </v-tabs>

              <v-tabs-items 
                v-model="active"
              > 
                <v-tab-item v-show="active === 0">
                  <v-container>
                    <v-row>
                      <v-col 
                        cols="12"
                        sm="6" 
                        lg="5"
                        xl="4"
                      >
                        <span class="font-weight-medium ml-8">Course Name:</span>
                      </v-col>
                      <v-col>
                        {{ course.name }}
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col 
                        cols="12"
                        sm="6" 
                        lg="5"
                        xl="4"
                      >
                        <span class="font-weight-medium ml-8">Description:</span>
                      </v-col>

                      <v-col>
                        {{ course.description }}
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col 
                        cols="12"
                        sm="6" 
                        lg="5"
                        xl="4"
                      >
                        <span class="font-weight-medium ml-8">Training Date:</span>
                      </v-col>

                      <v-col>
                        <v-row
                          v-for="training_session in course.training_sessions"
                          :key="training_session.id"
                        >
                          <span v-if="training_session.participants.length > 0"> 
                            <v-col class="py-0">
                              {{ $moment(training_session.time,'HH:mm::ss').format('hh:mm A') }}  {{ $moment(training_session.date).format('D MMMM YYYY') }}  
                            </v-col>
                          </span>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item v-show="active === 1">
                  <v-container class="pt-0">
                    <v-row>
                      <v-col cols="12">
                        <v-container class="course-material-container">
                          <v-card
                            v-for="courseMaterial in course.course_materials"
                            :key="courseMaterial.id"
                            class="mt-2 mb-2"
                          >
                            <v-row>
                              <v-col 
                                cols="12"
                                sm="6" 
                                lg="5"
                                xl="4"
                                class="ml-8"
                              >
                                <div class="font-weight-medium">
                                  {{ courseMaterial.name }}
                                </div>
                                <div> {{ courseMaterial.description }}</div>
                              </v-col>
                            </v-row>
    
                            <v-row>
                              <v-col 
                                cols="12"
                                sm="6" 
                                lg="5"
                                xl="4"
                                class="ml-8 py-0"
                              >
                                <span class="font-weight-medium">Materials:</span>
                              </v-col>
                            </v-row>
 
                            <span v-if="courseMaterial.documents.length == 0 && courseMaterial.links.length == 0">
                              <v-row>
                                <v-col 
                                  cols="12"
                                  sm="6" 
                                  lg="5"
                                  xl="4"
                                  class="ml-8 py-0"
                                >
                                  N/A
                                </v-col>
                              </v-row>
                            </span>

                            <span v-if="courseMaterial.course_material_type.extension ==='.pdf'">
                              <div
                                v-for="document in courseMaterial.documents"
                                :key="document.id"
                                class="ml-8"
                              >
                                <v-row class="pl-2 pb-1"> 
                                  <v-icon
                                    color="red"
                                  >
                                    mdi-file-pdf
                                  </v-icon>
                                  <v-btn
                                    text
                                    :href="document.file_url"
                                    target="_blank"
                                  >
                                    {{ document.file_name }}
                                  </v-btn>
                                </v-row>
                              </div>
                            </span>

                            <span v-else-if="courseMaterial.course_material_type.extension ==='.jpg,.jpeg,.png'">
                              <v-row
                                class="text-center"
                              >
                                <v-col
                                  v-for="document in courseMaterial.documents"
                                  :key="document.id"
                                  class="d-flex child-flex"
                                  cols="4"
                                >
                                  <v-row> 
                                    <div class="margin-auto">
                                      <a
                                        :href="document.file_url"
                                        target="_blank"
                                      >
                                        <v-img
                                          class="image-center"
                                          aspect-ratio="1"
                                          width="200"
                                          height="200"
                                          :src="document.file_url"
                                        /> 
                                      </a>
                                      <v-row
                                        align="center"
                                        justify="center"
                                      >
                                        {{ document.file_name }}
                                      </v-row>
                                    </div>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </span>

                            <span v-else-if="courseMaterial.course_material_type.extension ==='.mp3,.ogg'">
                              <v-row
                                class="text-center"
                              >
                                <v-col
                                  v-for="document in courseMaterial.documents"
                                  :key="document.id"
                                  class="d-flex child-flex"
                                  cols="4"
                                >
                       
                                  <v-row> 
                                    <div class="margin-auto">
                                      <audio controls>
                                        <source
                                          :src="document.file_url"
                                        >
                                      </audio>
                                    </div>
                                  </v-row>
                                 
                                </v-col>
                              </v-row>
                            </span>

                            <span v-else-if="courseMaterial.course_material_type.extension ==='link'">
                              <v-row>
                                <v-col
                                  v-for="link in courseMaterial.links"
                                  :key="link.id"
                                  class="d-flex child-flex"
                                  cols="4"
                                >
                                  <v-row> 
                                    <div class="margin-auto">
                                      <iframe
                                        class="px-10"
                                        :src="link.file_link"
                                        width="500"
                                        height="300"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                      />
                                    </div>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </span>
                          </v-card>
                        </v-container>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item v-show="active === 2">
                  <v-container>
                    <v-data-table
                      :headers="headers"
                      :single-expand="true"
                      show-expand
                      :items="myExams"
                    >
                      <template v-slot:item="props">
                        <tr>
                          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
                            <v-btn
                              icon
                              @click="props.expand(!props.isExpanded)"
                            >
                              <v-icon small> 
                                {{ props.isExpanded ? 'fa-chevron-up':'fa-chevron-down' }} 
                              </v-icon>
                            </v-btn>
                          </td>

                          <td :class="props.isExpanded? 'text-left remove-bottom-border':'text-left border-bottom'">
                            {{ props.item.name }}
                          </td>
                          <td :class="props.isExpanded? 'text-center remove-bottom-border':'text-center border-bottom'">
                            {{ props.item.passing_score }}
                          </td>
                          <td :class="props.isExpanded? 'text-center remove-bottom-border':'text-center border-bottom'">
                            {{ props.item.duration }}
                          </td>
                          <td :class="props.isExpanded? 'text-center remove-bottom-border':'text-center border-bottom'">
                            {{ props.item.max_attempt }}
                          </td>
                          <td :class="props.isExpanded? 'text-center remove-bottom-border':'text-center border-bottom'">
                            {{ $moment(props.item.start_date).format('DD-MM-YYYY HH:mm A') }}
                          </td>
                          <td :class="props.isExpanded? 'text-center remove-bottom-border':'text-center border-bottom'">
                            {{ $moment(props.item.end_date).format('DD-MM-YYYY HH:mm A') }}
                          </td>
                          <td :class="props.isExpanded? 'text-center remove-bottom-border':'text-center border-bottom'">
                            {{ props.item.highest_score }}
                          </td>
                          <td :class="props.isExpanded? 'text-center font-weight-bold remove-bottom-border':'text-center font-weight-bold border-bottom'">
                            <span :class="props.item.highest_score !== null? props.item.highest_score>props.item.passing_score?'green--text':'red--text':''">
                              {{ props.item.highest_score !== null? props.item.highest_score>props.item.passing_score?'PASS':'FAIL':'' }}
                            </span>
                          </td>
                          <td :class="props.isExpanded? 'text-center remove-bottom-border':'text-center border-bottom'">
                            <setup-training-participants-dialog-exam
                              :exam="props.item"
                              @completed="loadExams"
                            />
                          </td>
                        </tr>
                      </template>
                      
                      <template v-slot:expanded-item="{ header,item }">   
                        <td
                          :colspan="12"
                          class="attempt-border-bottom"
                        >
                          <div class="my-3 px-12">
                            <v-data-table
                              dense
                              fixed-header
                              disable-pagination
                              hide-default-footer
                              :headers="attemptHeaders"
                              :items="item.exam_attempts"
                              class="attempt-border attempt-scrollbar attempt-table"
                            >
                              <template v-slot:item.score="{ item }">
                                <span>
                                  <span v-if="item.score !== null">
                                    {{ item.score }}
                                  </span>
                                  <span
                                    v-else
                                    class="warning--text"
                                  >
                                    {{ 'Pending' }}
                                  </span>
                                </span>
                              </template>
                              <template v-slot:item.duration="{ item }">
                                <span>
                                  {{ item.duration }}
                                </span>
                              </template>
                              <template v-slot:item.created_at="{ item }">
                                <span>
                                  {{ $moment( item.created_at).format('DD-MM-YYYY HH:mm A') }}
                                </span>
                              </template>
                            </v-data-table>
                          </div>
                        </td>
                      </template>
                    </v-data-table>
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    components: {
      SetupTrainingParticipantsDialogExam: () => import('@/components/setup/training/participants/DialogExam'),
    },
    props: {
      courseId: {
        type: Number,
        default: null,
      },     
    },
    data () {
      return {
        active: 0,   
        loading: false,    
        course: null,
        myExams: [],
        expanded: [],
        headers: [
          { text: '', value: 'data-table-expand' },
          { text: 'Name', value: 'name', align: 'left' },
          { text: 'Passing Score(%)', sortable: false, value: 'passing_score', align: 'center' },
          { text: 'Duration(mins)', sortable: false, value: 'duration', align: 'center' },
          { text: 'Max. Attempts', sortable: false, value: 'max_attempt', align: 'center' },
          { text: 'Start Date', sortable: false, value: 'start_date', align: 'center' },
          { text: 'End Date', sortable: false, value: 'end_date', align: 'center' },
          { text: 'Best Score(%)', sortable: false, value: 'highest_score', align: 'center' },
          { text: 'Result', sortable: false, value: 'result', align: 'center' },
          { text: '', sortable: false, value: 'action', align: 'center' },
        ],
        attemptHeaders: [
          { text: 'Score(%)', sortable: false, value: 'score', align: 'center' },
          { text: 'Duration(mins)', sortable: false, value: 'duration', align: 'center' },
          { text: 'Taken On', sortable: false, value: 'created_at', align: 'center' },
        ],
      }
    },

    watch: {
      courseId: {
        immediate: true,
        handler (oldValue, newValue) {
          if (newValue || (oldValue !== newValue)) {            
            this.loadCourse()
            this.loadExams()
          }
        },
      },
    },
    methods: {
      loadCourse () {
        this.loading = true

        this.$api.courses().listCourseDetails(this.courseId)
          .then(res => {
            this.course = res.data
            this.loading = false
          })
      },
      loadExams () {
        this.$api.myExams().list(this.courseId)
          .then(res => {
            res.data.map(exam => {
              exam.highest_score = exam.exam_attempts.length > 0 ? exam.exam_attempts[0].score : null
            })

            this.myExams = _.orderBy(res.data, ['start_date'], ['desc'])
          })
      },
    },
  }
</script>

<style scoped>
.margin-auto{
  margin:auto;
}

.course-material-container{
  overflow-y:auto;
  height:420px;
}

::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background:  #555; 
}

.remove-bottom-border {
    border-bottom: 0px !important
}

.border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}
.attempt-border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.attempt-border{
  border:1px solid #e0e0e0;
  border-radius:10px
}
.attempt-scrollbar >>> ::-webkit-scrollbar {
  width: 3px;
}
.attempt-scrollbar >>> ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}
.attempt-scrollbar >>> ::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}
.attempt-scrollbar >>> ::-webkit-scrollbar-thumb:hover {
  background:  #555; 
}
.attempt-table >>> .v-data-table__wrapper{
  max-height:250px;
}
</style>
